import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {FormBuilder} from "@angular/forms";
import {takeUntil} from "rxjs/operators";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {
  RegistrationAddDialogComponent
} from "../../../registrations/registration-add-dialog/registration-add-dialog.component";
import {StatementAddDialogComponent} from "../../statement/statement-add-dialog/statement-add-dialog.component";
import {Ofwca} from "../../../../shared/interface/ofwca";
import {PartnerService} from "../../../../shared/services/partner.service";
import {Partner} from "../../../../shared/interface/partner";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesBalance, ReceivablesBalanceNote} from "../../../../shared/interface/receivables-balance";
import {ReceivablesBalanceService} from "../../../../shared/services/receivables-balance.service";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {RECEIVABLES_IMPORT_ROW_STATUS} from "../../../../shared/services/dict.service";
import {Support} from "../../../../shared/interface/support";
import {
  OfwcaChangeAccountNumberDialogComponent
} from "../../../ofwcas/ofwca-change-account-number-dialog/ofwca-change-account-number-dialog.component";
import {
  ReceivablesBalanceUpdatePartnerFacilityComponent
} from "../receivables-balance-update-partner-facility/receivables-balance-update-partner-facility.component";
import {
  ReceivablesBalanceUpdateOfwcaComponent
} from "../receivables-balance-update-ofwca/receivables-balance-update-ofwca.component";
import {
  ReceivablesBalanceNoteAddComponent
} from "../receivables-balance-note-add/receivables-balance-note-add.component";
import {ListResponse} from "../../../../shared/interface/response/list-response";
import {Contract} from "../../../../shared/interface/contract";

@Component({
  selector: 'app-receivables-balance-details',
  templateUrl: './receivables-balance-details.component.html',
  styleUrls: ['./receivables-balance-details.component.scss']
})
export class ReceivablesBalanceDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  receivablesBalanceId: string;
  userPermissions: ReplaySubject<UserPermissions>;
  selectedTab: number;
  receivablesBalanceObject?: ReceivablesBalance = null;
  receivablesBalance: ReplaySubject<ReceivablesBalance> = new ReplaySubject<ReceivablesBalance>(1);
  receivablesBalanceNotes: ReplaySubject<ReceivablesBalanceNote[]> = new ReplaySubject<ReceivablesBalanceNote[]>(1);


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private fb: FormBuilder,
    private receivablesBalanceService: ReceivablesBalanceService
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(params => {
        if (params.id === undefined) {
          return;
        }
        this.receivablesBalanceId = params.id;
        this.load();
      });
  }

  ngAfterViewInit(): void {
  }

  load(): void {
    this.receivablesBalanceService.get(this.receivablesBalanceId).subscribe((receivablesBalance: ReceivablesBalance) => {
      this.receivablesBalance.next(receivablesBalance);
      this.receivablesBalanceObject = receivablesBalance;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/naleznosci/salda/lista/partner']);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.tab.textLabel === 'Notatki') {
      this.loadNotes();
    }
  }


  updateBalance(val: boolean): void {
    let textVal;
    textVal = '' ;
    if (val) {
       textVal = 'Czy na pewno chcesz odblokować saldo?';
    } else {
       textVal = 'Czy na pewno chcesz zablokować saldo?';
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: textVal},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesBalanceService.activeUpdate({'active': val}, this.receivablesBalanceId)
          .subscribe(() => {
            this.load();
            if (val) {
              this.snack.open('Pomyślnie odblokowano saldo', '', {
                duration: 2000
              });
            } else {
              this.snack.open('Pomyślnie zablokowano saldo','', {
                duration: 2000
              });            }
          });
      }
    });
  }

  deleteOfwca(): void {
    let textVal;
    textVal = '' ;
    textVal = 'Czy na pewno chcesz odpiąć OFWCA?';


    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: textVal},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesBalanceService.sendUpdateOfwca({ 'ofwca' : null }, this.receivablesBalanceId)
          .subscribe(() => {
            this.load();
              this.snack.open('Pomyślnie odpięto OFWCA','', {
                duration: 2000
              });
          });
      }
    });
  }

  deletePartnerFacility(): void {
    let textVal;
    textVal = '' ;
    textVal = 'Czy na pewno chcesz odpiąć placówkę?';


    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: textVal},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesBalanceService.sendUpdatePartnerFacility({ 'partnerFacility' : null }, this.receivablesBalanceId)
          .subscribe(() => {
            this.load();
            this.snack.open('Pomyślnie odpięto placówkę','', {
              duration: 2000
            });
          });
      }
    });
  }

  addPartnerFacility(): void {
    const dialogRef = this.dialog.open(ReceivablesBalanceUpdatePartnerFacilityComponent, {
      width: '700px',
      data: {
        partnerId: this.receivablesBalanceObject?.ofwca?.partner?.uuid,
        receivableBalanceId: this.receivablesBalanceObject?.uuid},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.load();
    });
  }

  addOfwca(): void {
    const dialogRef = this.dialog.open(ReceivablesBalanceUpdateOfwcaComponent, {
      width: '700px',
      data: {
        partnerId: this.receivablesBalanceObject?.partner?.uuid,
        receivableBalanceId: this.receivablesBalanceObject?.uuid},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.load();
    });
  }

  addNote(): void {
    const dialogRef = this.dialog.open(ReceivablesBalanceNoteAddComponent, {
      width: '700px',
      data: {
        receivablesBalance: this.receivablesBalanceObject},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.load();
    });
  }

  send(uuid: string): void {
    this.receivablesBalanceService.sendEmail(uuid)
      .subscribe((response) => {
        this.snack.open('Pomyślnie wysłano komunikat',  '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy wysyłąniu wystąpił błąd', error.status.toString(), {duration: 2000});
        if (error.status === 400) {
          this.snack.open(error.error.error.text, '400', {duration: 4000});
        }
      });

  }

  restart(uuid: string): void {
    this.receivablesBalanceService.restart(uuid)
      .subscribe((response) => {
        this.load();
        this.snack.open('Pomyślnie zaktualizowano saldo',  '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy wysyłąniu wystąpił błąd', error.status.toString(), {duration: 2000});
        if (error.status === 400) {
          this.snack.open(error.error.error.text, '400', {duration: 4000});
        }
      });

  }


  loadNotes(): void {
    this.receivablesBalanceService.getReceivablesBalanceNote(this.receivablesBalanceObject.uuid)
      .subscribe((contracts: ListResponse<Contract>) => {
        this.receivablesBalanceNotes.next(contracts.items);
      });
  }

}
